import { render, staticRenderFns } from "./PreventiveHealthAndVacination.vue?vue&type=template&id=05ce5a50&"
import script from "./PreventiveHealthAndVacination.vue?vue&type=script&lang=js&"
export * from "./PreventiveHealthAndVacination.vue?vue&type=script&lang=js&"
import style0 from "./PreventiveHealthAndVacination.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports